import type { ReactNode, RefObject } from 'react';
import { Button, ButtonGroup } from '@/shared/ui/button/button';
import { Popup } from '@/shared/ui/popup/popup';

export interface AlertProps {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  message: ReactNode;
  confirmLabel?: string;
  triggerRef?: RefObject<HTMLElement | null>;
}

export function Alert({ open, onClose, title, message, confirmLabel = '확인', triggerRef }: AlertProps) {
  return (
    <Popup
      open={open}
      onClose={onClose}
      title={title}
      description={message}
      triggerRef={triggerRef}
      footer={
        <ButtonGroup>
          <Button variant="primary" onClick={onClose}>
            {confirmLabel}
          </Button>
        </ButtonGroup>
      }
    />
  );
}
